import styled from 'styled-components';

export const Wrapper = styled.div`
  &:first-child {
    margin-bottom: 16px !important;
  }
`;
